// Primary 6 English Learning Data
// Combined from p6Data-part1.js and p6Data-part2.js
// Based on Primary English Learning P6 Topics.txt

import { p6DataPart1 } from './p6Data-part1';
import { p6DataPart2 } from './p6Data-part2';

export const p6Data = {
  gradeId: p6DataPart1.gradeId,
  gradeName: p6DataPart1.gradeName,
  objectives: p6DataPart1.objectives,
  keySkills: p6DataPart1.keySkills,
  topics: [
    ...p6DataPart1.topics,
    ...p6DataPart2.topics
  ]
}; 